import * as tslib_1 from "tslib";
var ObjectWithLinks = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectWithLinks, _super);
    function ObjectWithLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ObjectWithLinks;
}(Object));
export { ObjectWithLinks };
//# sourceMappingURL=objectWithLinks.js.map